<template>
  <v-row justify="center">
    <v-col cols="12" lg="11" class="agent-container">
      <!-- Header with Add User Button -->
      <div class="header-actions">
        <v-btn color="primary" class="add-user-btn" elevation="2" @click="openCreateDIalog()">
          <v-icon left>mdi-account-plus</v-icon>
          פתח משתמש חדש
        </v-btn>
      </div>

      <!-- Search and Stats Card -->
      <v-card class="search-card" elevation="2">
        <v-card-text>
          <v-row align="center">
            <v-col cols="12" md="4" sm="6">
              <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" label="חיפוש משתמש" outlined dense
                hide-details background-color="white" class="search-field" @input="handleSearchInput"></v-text-field>
            </v-col>
            <v-col cols="12" md="8" sm="6" class="d-flex align-center">
              <div class="users-count">
                <v-icon color="#0d2c6d" class="ml-2">mdi-account-group</v-icon>
                <span>סך הכל <strong>{{ totalItems }}</strong> משתמשים</span>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Users Data Table Card -->
      <v-card class="data-table-card" elevation="2">
        <v-data-table id="table1" :headers="headers" :items="ivrs" :loading="progressShow" loading-text="טוען נתונים..."
          :server-items-length="totalItems" :items-per-page="itemsPerPage" :page.sync="currentPage"
          :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @update:items-per-page="onItemsPerPageChange"
          @update:page="onPageChange" @update:sort-by="onSortChange" @update:sort-desc="onSortChange" :footer-props="{
            'items-per-page-options': [20, 50, 100, 500],
            'items-per-page-text': 'שורות בעמוד:',
            showFirstLastPage: true,
            firstIcon: 'mdi-chevron-double-left',
            lastIcon: 'mdi-chevron-double-right',
            prevIcon: 'mdi-chevron-left',
            nextIcon: 'mdi-chevron-right'
          }" class="users-table">
          <template v-if="$vuetify.breakpoint.mdAndUp" v-for="header in headers"
            v-slot:[`header.${header.value}`]="{ header }">
            <span class="table-header-text">{{ header.text }}</span>
          </template>

          <template v-if="$vuetify.breakpoint.mdAndUp" #item="{ item, index }">
            <tr :class="item.status ? 'table-row' : 'table-row-disabled'">
              <td class="table-cell">{{ rowNumber(index) }}</td>
              <td class="table-cell">{{ item.line_number }}</td>
              <td class="table-cell">{{ item.owner_details.name }}</td>
              <td class="table-cell">{{ item.owner_details.business_name }}</td>
              <td class="table-cell">{{ item.owner_details.phone }}</td>
              <td class="table-cell">{{ item.owner_details.email || 'אין מייל' }}</td>
              <td class="table-cell">{{ item.last_call ? formatDate(item.last_call) : '-' }}</td>
              <td class="table-cell">{{ item.last_visit || 'לא התחבר' }}</td>
              <td class="table-cell">
                <v-chip small color="#6a6aec" text-color="white">
                  {{ planName(item) }}
                </v-chip>
              </td>
              <td class="table-cell">{{ formatDate(item.createdAt) }}</td>
              <td class="table-cell">
                <div class="action-buttons">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn icon small v-on="on" color="#0d2c6d" @click="openEditDialog(item)">
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>עריכה</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn icon small v-on="on" color="#ffb91a" @click="switchToUser(item)">
                        <v-icon>mdi-login-variant</v-icon>
                      </v-btn>
                    </template>
                    <span>כניסה למערכת</span>
                  </v-tooltip>
                </div>
              </td>
            </tr>
          </template>

          <!-- Mobile display -->
          <template v-slot:item.actions="{ item }">
            <div class="action-buttons">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon small v-on="on" color="#0d2c6d" @click="openEditDialog(item)">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>עריכה</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon small v-on="on" color="#ffb91a" @click="switchToUser(item)">
                    <v-icon>mdi-login-variant</v-icon>
                  </v-btn>
                </template>
                <span>כניסה למערכת</span>
              </v-tooltip>
            </div>
          </template>

          <template v-slot:no-data>
            <v-row v-if="progressShow" class="my-5">
              <v-col class="d-flex justify-center">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
              </v-col>
            </v-row>
            <div v-else class="empty-state">
              <v-icon size="64" color="#0d2c6d">mdi-account-off</v-icon>
              <span class="empty-text">{{ search ? 'לא נמצאו משתמשים' : 'אין עדיין משתמשים' }}</span>
              <v-btn color="primary" @click="refreshDetails()" class="mt-4">
                <v-icon left>mdi-refresh</v-icon>
                רענן
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-card>

      <!-- Dialogs -->
      <AddEditDialog v-model="addEditDialog" v-if="addEditDialog" :formTitle="formTitle" :itemToEdit="editedItem"
        @ivrCreated="newIvrSaved" @ivrEdited="editedIvrSaved"></AddEditDialog>

      <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>
    </v-col>
  </v-row>
</template>

<script>
import ApiServices from '@/services/api.service'
import SnackBar from '@/components/widgets/snackBar.vue'
import utils from '@/util/utils'
import Auth from '@/services/auth.service.js'
import AddEditDialog from '@/components/agent/dialogs/AddEditDialog'
import { mapMutations } from 'vuex';
import _ from 'lodash'

export default {
  components: {
    SnackBar,
    AddEditDialog
  },
  data: () => ({
    snackbar: false,
    snackbarColorBt: "green",
    snacbarText: "",
    lineNumber: "",
    progressShow: false,
    addEditDialog: false,
    formTitle: "",
    editedItem: {},
    search: "",
    ivrs: [],
    // === מצב פייג'ינג בצד שרת ===
    totalItems: 0,
    currentPage: 1,
    itemsPerPage: 20,
    sortBy: 'createdAt',
    sortDesc: true,
    debouncedGetIvrs: null,
    headers: [
      { text: '#', value: "index", sortable: false, width: '50px' },
      { text: 'שם משתמש', value: 'line_number', align: 'center' },
      { text: 'שם איש קשר', value: 'owner_details.name', align: 'center' },
      { text: 'שם מוסד', value: 'owner_details.business_name', align: 'center' },
      { text: 'טלפון', value: 'owner_details.phone', align: 'center' },
      { text: 'דוא"ל', value: 'owner_details.email', align: 'center' },
      { text: 'שיחה אחרונה', value: 'last_call', align: 'center' },
      { text: 'התחברות אחרונה', value: 'last_visit', align: 'center' },
      { text: 'חבילה', value: 'plan.plan_name', align: 'center', width: '120px' },
      { text: 'נוצר בתאריך', value: 'createdAt', align: 'center', width: '120px' },
      { text: 'פעולות', value: 'actions', sortable: false, width: '120px' },
    ],
  }),
  methods: {
    ...mapMutations(['TOGGLE_AGENT_SWITCH']),

    async getIvrs(resetPage = false) {
      try {
        if (resetPage) {
          this.currentPage = 1;
        }
        this.progressShow = true;
        let token = localStorage.getItem("token");

        const query = new URLSearchParams({
          page: this.currentPage,
          itemsPerPage: this.itemsPerPage,
          sortBy: this.sortBy || '',
          sortDesc: this.sortDesc ? 'desc' : 'asc',
          search: this.search || ''
        }).toString();

        let api = process.env.VUE_APP_BASE_URL + `/agent_api/get_ivrs_list?${query}`;
        const res = await fetch(api, ApiServices.requestOptions("GET", "", token));
        const jsonObject = await res.json();
        this.progressShow = false;
        if (res.status >= 400) {
          this.showSnackBar("שגיאה בקבלת נתונים", "red");
        } else if (res.status === 200) {
          this.ivrs = jsonObject.items || [];
          this.totalItems = jsonObject.totalItems || 0;
        }
      } catch (error) {
        this.progressShow = false;
        this.showSnackBar("Error get subscribes: " + error, "red");
      }
    },
    formatDate(date) {
      return utils.getCurrentDate(date);
    },
    // מספור רץ שממשיך בין עמודים
    rowNumber(index) {
      return (this.currentPage - 1) * this.itemsPerPage + index + 1;
    },
    planName(item) {
      if (!item.plan) {
        return '-';
      }
      if (item.plan.plan_id && item.plan.plan_id.name) {
        return item.plan.plan_id.name;
      }
      return item.plan.plan_name || '-';
    },
    showSnackBar(message, color) {
      this.snacbarText = message;
      this.snackbarColorBt = color;
      this.snackbar = true;
    },
    openEditDialog(item) {
      this.formTitle = "ערוך משתמש:";
      this.editedItem = item;
      this.addEditDialog = true;
    },
    openCreateDIalog() {
      this.formTitle = "פתח משתמש חדש:";
      this.editedItem = {};
      this.addEditDialog = true;
    },
    newIvrSaved(item, text, color) {
      this.showSnackBar(text, color);
      if (item === "") {
        return;
      }
      // עם פייג'ינג בצד שרת אין לדחוף לרשימה מקומית – טוענים מחדש
      this.getIvrs(true);
    },
    editedIvrSaved(item, text, color) {
      this.showSnackBar(text, color);
      if (item === "") {
        return;
      }
      this.getIvrs();
    },
    async switchToUser(item) {
      this.progressShow = true;
      let token = localStorage.getItem("token");
      let MyJSON = JSON.stringify({ _id: item._id });
      let api = process.env.VUE_APP_BASE_URL + "/agent_api/swich_to_user";

      try {
        const response = await fetch(api, ApiServices.requestOptions("POST", MyJSON, token));
        this.progressShow = false;
        const jsonObject = await response.json();
        if (response.status >= 400) {
          this.showSnackBar("שגיאת התחברות: " + jsonObject.message, "red");
        } else if (response.status === 200) {
          localStorage.setItem('tokenAgent', token);
          localStorage.setItem('token', jsonObject.token);
          this.TOGGLE_AGENT_SWITCH();
          this.$router.replace({ name: "home" });
        }
      } catch (error) {
        this.progressShow = false;
        this.showSnackBar("Error Login: " + error, "red");
      }
    },
    refreshDetails() {
      this.getIvrs();
    },
    // === events של פייג'ינג בצד שרת ===
    onPageChange(newPage) {
      this.currentPage = newPage;
      this.getIvrs();
    },
    onItemsPerPageChange(newItemsPerPage) {
      this.itemsPerPage = newItemsPerPage;
      this.getIvrs(true);
    },
    onSortChange() {
      this.debouncedGetIvrs(true);
    },
    handleSearchInput() {
      this.debouncedGetIvrs(true);
    },
  },
  created() {
    this.debouncedGetIvrs = _.debounce(this.getIvrs, 700);
  },
  mounted() {
    this.lineNumber = Auth.getLineNumber();
    this.getIvrs();
  },
}
</script>

<style scoped>
.agent-container {
  font-family: 'Heebo', sans-serif;
}

.header-actions {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 24px;
}

.add-user-btn {
  background: linear-gradient(135deg, #ffb91a 0%, #ffd166 100%) !important;
  color: #0d2c6d !important;
  font-weight: 600;
  padding: 0 24px;
  height: 48px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.add-user-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.search-card {
  margin-bottom: 24px;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.search-card:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1) !important;
}

.search-field {
  border-radius: 8px;
}

.users-count {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #0d2c6d;
}

.data-table-card {
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  margin-bottom: 40px;
}

.data-table-card:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1) !important;
}

.users-table {
  width: 100%;
}

.table-header-text {
  font-size: 16px;
  font-weight: 600;
  color: #0d2c6d;
}

.table-row {
  height: 60px !important;
  transition: background-color 0.2s ease;
}

.table-row-disabled {
  height: 60px !important;
  background-color: rgba(243, 32, 60, 0.178) !important;
}

.table-row:hover {
  background-color: rgba(13, 44, 109, 0.05) !important;
}

.table-cell {
  font-size: 14px;
  color: #333;
  text-align: center !important;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 8px;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 0;
}

.empty-text {
  font-size: 20px;
  font-weight: 600;
  color: #0d2c6d;
  margin-top: 16px;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .agent-container {
    padding: 0 12px;
  }

  .header-actions {
    margin-bottom: 16px;
  }

  .table-header-text {
    font-size: 14px;
  }

  .table-cell {
    font-size: 13px;
  }
}

@media (max-width: 600px) {
  .add-user-btn {
    width: 100%;
  }

  .search-card,
  .data-table-card {
    border-radius: 8px;
  }

  .users-count {
    justify-content: center;
    margin-top: 8px;
  }
}

#table1.v-data-table>>>.v-data-table-header th {
  background-color: rgba(0, 0, 0, 0.116) !important;
  border-left: 1px solid white !important;
}
</style>